var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 3.429,
    viewBox: "0 0 16 3.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-minus",
    "data-name": "Icon awesome-minus",
    d: "M14.857,14.625H1.143A1.143,1.143,0,0,0,0,15.768v1.143a1.143,1.143,0,0,0,1.143,1.143H14.857A1.143,1.143,0,0,0,16,16.911V15.768A1.143,1.143,0,0,0,14.857,14.625Z",
    transform: "translate(0 -14.625)",
    fill: "#4d4d4d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.82807b577c1893c5385d421849412677.svg";
export { ForwardRef as ReactComponent };